import { defineComponent as _defineComponent } from 'vue'
import { SdsMaximumUpload } from '@/lib/enum';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyContractView',
  props: {
    maximumUpload: null
  },
  setup(__props: any) {

const props = __props as {
  maximumUpload: number;
};

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  currentPlan: '現在のプラン',
});



const getPlanDetail = (upload: number) => {
  const maximumUpload = SdsMaximumUpload.fromUpload(upload);

  if (maximumUpload.isFree()) {
    return `${$t(sharedMessages.sdsCounter, {
      count: maximumUpload.value,
    })} (${$t(sharedMessages.freeTrial)})`;
  } else if (maximumUpload.isUnlimited()) {
    return `${$t(sharedMessages.unlimited)}`;
  } else if (maximumUpload.isPaid()) {
    return `${$t(sharedMessages.sdsCounter, {
      count: maximumUpload.value,
    })} (${$t(sharedMessages.paidPlan)})`;
  }
};

return { __sfc: true,$t, m, props, getPlanDetail }
}

})